module.exports = __webpack_public_path__ + "media/dashboard/assets/images/channels/microsoft-9e04ceebdd11f16d6fa2a38cf365c2e9.png";